import axiosImport from 'axios';

const axios = axiosImport.create();

export default axios;
